module.exports = __webpack_public_path__ + "img/app_store.1af05090.svg";